import React from 'react';
import CheckBox from './CheckBox';


export default function CheckBoxList({ options, isCheckedAll, onCheck }) {
    let selectedRolesArray = []
    const checkBoxOptions = (
        <div className="checkbox-list">
            {options.map((option, index) => {
                return (
                    <CheckBox
                        key={index}
                        name={option.name}
                        value={option.value}
                        tick={option.checked}
                        usersCount={option.users}
                        onCheck={(e) => onCheck(option.value, e.target.checked)}
                    />
                );
            },
            )}
        </div>
    );
    let roleCount = 0;
    let countTotalRoles = options.length;
    let rolesListArray = {};
    let usersCount = 0;
    //Selected Count
    options.map((role, index) => {
        if (role.checked) {
            roleCount = roleCount + 1;
            rolesListArray = role;
            selectedRolesArray = role.value;
            usersCount = role.users;
        }
    });
    return (
        <div>

            <div className="main-body-heading-block">
                <span className="main-text">Roles</span>
                <span className="count-tag-styling">({roleCount}/{countTotalRoles})</span>
            </div>
            <div className="roles-list-block">
                <CheckBox
                    name="select-all"
                    value="ALL"
                    tick={isCheckedAll}
                    onCheck={(e) => onCheck('all', e.target.checked)}
                    className="custom-control-input selectAllRolesCheckbox"
                />
                {checkBoxOptions}
            </div>
        </div>
    );
}
